// Stub for cloudfront_ui's dashboard header context.
// Only the setTitle / setActions surface is used by blyn pages.

import { createContext, useContext, useState } from 'react'
import type { ReactNode } from 'react'

export interface BreadcrumbItem {
  name: string
  href?: string
}

interface HeaderCtx {
  title: string
  setTitle: (title: string) => void
  setActions: (actions: ReactNode) => void
  setCustomBreadcrumbs: (crumbs: BreadcrumbItem[] | null) => void
}

const HeaderContext = createContext<HeaderCtx>({
  title: '',
  setTitle: () => {},
  setActions: () => {},
  setCustomBreadcrumbs: () => {},
})

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState('')
  const [, setActions] = useState<ReactNode>(null)
  const [, setCustomBreadcrumbs] = useState<BreadcrumbItem[] | null>(null)

  return (
    <HeaderContext.Provider value={{ title, setTitle, setActions, setCustomBreadcrumbs }}>
      {children}
    </HeaderContext.Provider>
  )
}

export function useHeaderContext() {
  return useContext(HeaderContext)
}
